<template>
    <div>
        <div class="cssload-container">
            <div class="cssload-double-torus" :class="{'is_blue': isBlue}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LoaderBottom",
        props: {
            isBlue: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped lang="scss">
    .cssload-container {
        width: 100%;
        height: 22px;
        text-align: center;
    }

    .cssload-double-torus {
        width: 20px;
        height: 20px;
        margin: 0 auto;
        border: 2px solid;
        border-radius: 50%;
        border-color: transparent rgba(255,255,255,0.9) rgba(255,255,255,0.9);
        animation: cssload-spin 690ms infinite linear;
        -o-animation: cssload-spin 690ms infinite linear;
        -ms-animation: cssload-spin 690ms infinite linear;
        -webkit-animation: cssload-spin 690ms infinite linear;
        -moz-animation: cssload-spin 690ms infinite linear;
    }
    .cssload-double-torus.is_blue {
        border-color: transparent #0049FF #0049FF;
    }
    @keyframes cssload-spin {
        100%{ transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-o-keyframes cssload-spin {
        100%{ -o-transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-ms-keyframes cssload-spin {
        100%{ -ms-transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-webkit-keyframes cssload-spin {
        100%{ -webkit-transform: rotate(360deg); transform: rotate(360deg); }
    }

    @-moz-keyframes cssload-spin {
        100%{ -moz-transform: rotate(360deg); transform: rotate(360deg); }
    }
</style>
